module.exports = __webpack_public_path__ + "img/instrtype.270b20de.gif";